import { useNavigate } from 'react-router-dom';
import './error404.css';

const SHARDS = Array.from({ length: 14 }, (_, i) => ({
  id: i,
  x: Math.random() * 100,
  y: Math.random() * 100,
  rot: Math.random() * 360,
  size: 20 + Math.random() * 60,
  color: ['#B5E917','#00E5FF','#FF2D78','#7B2FBE'][i % 4],
  delay: Math.random() * 3,
  dur: 3 + Math.random() * 4,
}));

export default function Error404() {
  const navigate = useNavigate();

  return (
    <div className="e404">
      {/* shards */}
      {SHARDS.map(s => (
        <div
          key={s.id}
          className="e404__shard"
          style={{
            left:             `${s.x}%`,
            top:              `${s.y}%`,
            '--sz':           `${s.size}px`,
            '--rot':          `${s.rot}deg`,
            '--clr':          s.color,
            animationDelay:   `${s.delay}s`,
            animationDuration:`${s.dur}s`,
          }}
        />
      ))}

      {/* grid */}
      <div className="e404__grid" />
      <div className="e404__vignette" />

      <div className="e404__center">
        {/* glitch 404 */}
        <div className="e404__number" data-text="404">
          <span>4</span><span className="e404__glitch-prism">◈</span><span>4</span>
        </div>

        <div className="e404__title" data-text="REALITY CORRUPTED">
          REALITY CORRUPTED
        </div>

        <p className="e404__sub">
          The dimensional rift has swallowed this page.<br />
          Your prism pals are lost in the void.
        </p>

        <button className="e404__btn" onClick={() => navigate('/splash')}>
          <span className="e404__btn-bg" />
          <span className="e404__btn-text">⟵ RETURN TO HOME</span>
        </button>
      </div>
    </div>
  );
}
